var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRESENTMENT_PRICE_RANGE_FRAGMENT = exports.PRICE_RANGE_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.PRICE_RANGE_FRAGMENT = (0, graphql_tag_1.default) `
  fragment PriceRangeFragment on ProductPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
    minVariantPrice {
      amount
      currencyCode
    }
  }
`;
exports.PRESENTMENT_PRICE_RANGE_FRAGMENT = (0, graphql_tag_1.default) `
  fragment PresentmentPriceRangeFragment on ProductPriceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
    minVariantPrice {
      amount
      currencyCode
    }
  }
`;
//# sourceMappingURL=priceRangeFragment.js.map